/**
 * Reusable data-driven trust/stat bar (cream). Renders a horizontal row of
 * statistics separated by thin vertical dividers. Values must be real or
 * clearly flagged as demo — never fabricate production numbers.
 *
 * items: [{ icon: LucideIcon, value: string|number, label: string, demo?: boolean }]
 */
export function StatBar({ items, className = "" }) {
  const visible = items.filter(Boolean);
  if (!visible.length) return null;
  return (
    <div className={`bg-bone border-y border-saddle/15 ${className}`} data-testid="stat-bar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-8 grid grid-cols-2 md:grid-cols-4 gap-y-8">
        {visible.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.label}
              className={`flex items-center gap-4 px-2 md:px-6 ${i > 0 ? "md:border-l border-saddle/20" : ""}`}
              data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {Icon && <Icon size={30} strokeWidth={1.4} className="text-saddle shrink-0" aria-hidden="true" />}
              <div className="leading-tight">
                <span className="block font-serif text-3xl md:text-4xl text-forest tracking-tight flex items-baseline gap-2">
                  {s.value}
                  {s.demo && <span className="text-[9px] font-sans uppercase tracking-wider text-earth/70 border border-earth/30 px-1 py-0.5 rounded-sm">demo</span>}
                </span>
                <span className="text-xs md:text-sm text-charcoal/60">{s.label}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
